import { useCallback, useEffect, useRef } from 'react';
import { useOktaAuth } from '@okta/okta-react';

import { OKTA_LOGOUT_URL } from '@frontend/envConfig';
import { useInstanceId } from '@frontend/hooks';
import { sendSentryError } from '@frontend/utils/sendSentryError';

import { optiGlobalHeaderStyles } from './OptiGlobalHeader.css';

type OptiGlobalHeaderProps = {
  visible?: boolean;
};

export function OptiGlobalHeader({ visible = true }: OptiGlobalHeaderProps) {
  const { authState, oktaAuth } = useOktaAuth();
  const headerRef = useRef<HTMLDivElement>(null);
  const { instanceId } = useInstanceId();
  const onLogout = useCallback(() => {
    oktaAuth
      .signOut({
        revokeAccessToken: true, // Revoke the access token
        revokeRefreshToken: true, // Revoke the refresh token (if granted offline_access scope)
        postLogoutRedirectUri: OKTA_LOGOUT_URL, // The URI to redirect after logout
      })
      .catch(err => sendSentryError(err));
  }, [oktaAuth]);

  useEffect(() => {
    const currentHeaderRef = headerRef.current;
    currentHeaderRef?.addEventListener?.('@opti-common-header:logout', onLogout);

    return () => {
      currentHeaderRef?.removeEventListener?.('@opti-common-header:logout', onLogout);
    };
  }, [headerRef, onLogout]);
  if (!instanceId) {
    return null;
  }
  return (
    <div className={visible ? optiGlobalHeaderStyles.visible : optiGlobalHeaderStyles.hidden}>
      <opti-common-header
        ref={headerRef}
        auth-token={authState?.accessToken?.accessToken}
        product-name="Opal"
        instance-id={instanceId}
      />
    </div>
  );
}
